import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
const FUARALANI_API = `${API_BASE_URL}/api/v1/fuaralani`;

// -------------------------------------------------------
// Mock Data  (API guide geldiğinde sadece USE_MOCK_DATA = false yapılacak)
// -------------------------------------------------------
const mockFuarAlaniList = [
  {
    id: 1,
    fuarAlaniName: "İstanbul Fuar Merkezi (CNR)",
    fuarAlaniNameEn: "Istanbul Fair Center (CNR)",
    location: "Yeşilköy, İstanbul",
    isActive: true,
    salons: [
      { id: 1, salonName: "Salon A", salonCode: "A" },
      { id: 2, salonName: "Salon B", salonCode: "B" },
      { id: 3, salonName: "Salon C", salonCode: "C" },
    ],
  },
  {
    id: 2,
    fuarAlaniName: "TÜYAP Fuar ve Kongre Merkezi",
    fuarAlaniNameEn: "TÜYAP Fair and Congress Center",
    location: "Büyükçekmece, İstanbul",
    isActive: true,
    salons: [
      { id: 4, salonName: "Salon 1", salonCode: "H1" },
      { id: 5, salonName: "Salon 2", salonCode: "H2" },
    ],
  },
  {
    id: 3,
    fuarAlaniName: "Ankara Fuar Merkezi",
    fuarAlaniNameEn: "Ankara Fair Center",
    location: "Ulus, Ankara",
    isActive: true,
    salons: [
      { id: 6, salonName: "Salon A", salonCode: "A" },
    ],
  },
  {
    id: 4,
    fuarAlaniName: "İzmir Kültürpark",
    fuarAlaniNameEn: "Izmir Kultürpark",
    location: "Konak, İzmir",
    isActive: false,
    salons: [],
  },
];

// Salonlar için ayrı mock (iç içe erişim kolaylığı için)
let mockSalonList = [
  { id: 1, fuarAlaniId: 1, salonName: "Salon A", salonCode: "A" },
  { id: 2, fuarAlaniId: 1, salonName: "Salon B", salonCode: "B" },
  { id: 3, fuarAlaniId: 1, salonName: "Salon C", salonCode: "C" },
  { id: 4, fuarAlaniId: 2, salonName: "Salon 1", salonCode: "H1" },
  { id: 5, fuarAlaniId: 2, salonName: "Salon 2", salonCode: "H2" },
  { id: 6, fuarAlaniId: 3, salonName: "Salon A", salonCode: "A" },
];

const USE_MOCK_DATA = true;

// -------------------------------------------------------
// Service
// -------------------------------------------------------
export const fuarAlaniService = {
  /**
   * Tüm fuar alanlarını listele
   * GET api/v1/fuaralani/list
   */
  async getFuarAlaniList() {
    if (USE_MOCK_DATA) {
      return [...mockFuarAlaniList];
    }
    try {
      const res = await axios.get(`${FUARALANI_API}/list`);
      return res.data;
    } catch (err) {
      console.error('getFuarAlaniList error:', err);
      throw err;
    }
  },

  /**
   * Tek fuar alanı detayı
   * GET api/v1/fuaralani/{id}
   */
  async getFuarAlaniDetail(id) {
    if (USE_MOCK_DATA) {
      const alan = mockFuarAlaniList.find((a) => a.id === id);
      if (!alan) throw new Error('Fuar alanı bulunamadı');
      return { ...alan };
    }
    try {
      const res = await axios.get(`${FUARALANI_API}/${id}`);
      return res.data;
    } catch (err) {
      console.error('getFuarAlaniDetail error:', err);
      throw err;
    }
  },

  /**
   * Yeni fuar alanı oluştur
   * POST api/v1/fuaralani/create
   */
  async createFuarAlani(payload) {
    if (USE_MOCK_DATA) {
      const newAlan = {
        id: Math.max(...mockFuarAlaniList.map((a) => a.id), 0) + 1,
        fuarAlaniName: payload.fuarAlaniName,
        fuarAlaniNameEn: payload.fuarAlaniNameEn || '',
        location: payload.location || '',
        isActive: payload.isActive ?? true,
        salons: [],
      };
      mockFuarAlaniList.push(newAlan);
      return { ...newAlan };
    }
    try {
      const res = await axios.post(`${FUARALANI_API}/create`, payload);
      return res.data;
    } catch (err) {
      console.error('createFuarAlani error:', err);
      throw err;
    }
  },

  /**
   * Fuar alanı güncelle
   * PUT api/v1/fuaralani/update/{id}
   */
  async updateFuarAlani(id, payload) {
    if (USE_MOCK_DATA) {
      const idx = mockFuarAlaniList.findIndex((a) => a.id === id);
      if (idx === -1) throw new Error('Fuar alanı bulunamadı');
      mockFuarAlaniList[idx] = { ...mockFuarAlaniList[idx], ...payload };
      return { ...mockFuarAlaniList[idx] };
    }
    try {
      const res = await axios.put(`${FUARALANI_API}/update/${id}`, payload);
      return res.data;
    } catch (err) {
      console.error('updateFuarAlani error:', err);
      throw err;
    }
  },

  /**
   * Fuar alanı sil (soft)
   * DELETE api/v1/fuaralani/delete/{id}
   */
  async deleteFuarAlani(id) {
    if (USE_MOCK_DATA) {
      const idx = mockFuarAlaniList.findIndex((a) => a.id === id);
      if (idx === -1) throw new Error('Fuar alanı bulunamadı');
      mockFuarAlaniList[idx].isActive = false; // soft delete
      return { success: true };
    }
    try {
      const res = await axios.delete(`${FUARALANI_API}/delete/${id}`);
      return res.data;
    } catch (err) {
      console.error('deleteFuarAlani error:', err);
      throw err;
    }
  },

  // -------------------------------------------------------
  // SALON işlemleri
  // -------------------------------------------------------

  /**
   * Belirli fuar alanının salonlarını getir
   * GET api/v1/fuaralani/{fuarAlaniId}/salons
   */
  async getSalonList(fuarAlaniId) {
    if (USE_MOCK_DATA) {
      return mockSalonList.filter((s) => s.fuarAlaniId === fuarAlaniId);
    }
    try {
      const res = await axios.get(`${FUARALANI_API}/${fuarAlaniId}/salons`);
      return res.data;
    } catch (err) {
      console.error('getSalonList error:', err);
      throw err;
    }
  },

  /**
   * Salon ekle
   * POST api/v1/fuaralani/{fuarAlaniId}/salons
   */
  async createSalon(fuarAlaniId, payload) {
    if (USE_MOCK_DATA) {
      const newSalon = {
        id: Math.max(...mockSalonList.map((s) => s.id), 0) + 1,
        fuarAlaniId,
        salonName: payload.salonName,
        salonCode: payload.salonCode || '',
      };
      mockSalonList.push(newSalon);

      // Ana listede de güncelle
      const alanIdx = mockFuarAlaniList.findIndex((a) => a.id === fuarAlaniId);
      if (alanIdx !== -1) {
        mockFuarAlaniList[alanIdx].salons.push({
          id: newSalon.id,
          salonName: newSalon.salonName,
          salonCode: newSalon.salonCode,
        });
      }
      return { ...newSalon };
    }
    try {
      const res = await axios.post(`${FUARALANI_API}/${fuarAlaniId}/salons`, payload);
      return res.data;
    } catch (err) {
      console.error('createSalon error:', err);
      throw err;
    }
  },

  /**
   * Salon güncelle
   * PUT api/v1/fuaralani/salons/{salonId}
   */
  async updateSalon(salonId, payload) {
    if (USE_MOCK_DATA) {
      const idx = mockSalonList.findIndex((s) => s.id === salonId);
      if (idx === -1) throw new Error('Salon bulunamadı');
      mockSalonList[idx] = { ...mockSalonList[idx], ...payload };
      return { ...mockSalonList[idx] };
    }
    try {
      const res = await axios.put(`${FUARALANI_API}/salons/${salonId}`, payload);
      return res.data;
    } catch (err) {
      console.error('updateSalon error:', err);
      throw err;
    }
  },

  /**
   * Salon sil
   * DELETE api/v1/fuaralani/salons/{salonId}
   */
  async deleteSalon(salonId) {
    if (USE_MOCK_DATA) {
      const idx = mockSalonList.findIndex((s) => s.id === salonId);
      if (idx === -1) throw new Error('Salon bulunamadı');
      const fuarAlaniId = mockSalonList[idx].fuarAlaniId;
      mockSalonList.splice(idx, 1);

      // Ana listede de güncelle
      const alanIdx = mockFuarAlaniList.findIndex((a) => a.id === fuarAlaniId);
      if (alanIdx !== -1) {
        mockFuarAlaniList[alanIdx].salons = mockFuarAlaniList[alanIdx].salons.filter(
          (s) => s.id !== salonId
        );
      }
      return { success: true };
    }
    try {
      const res = await axios.delete(`${FUARALANI_API}/salons/${salonId}`);
      return res.data;
    } catch (err) {
      console.error('deleteSalon error:', err);
      throw err;
    }
  },
};

